import { render, staticRenderFns } from "./ChronicDetail.vue?vue&type=template&id=6a4163e4"
import script from "./ChronicDetail.vue?vue&type=script&lang=js"
export * from "./ChronicDetail.vue?vue&type=script&lang=js"
import style0 from "./ChronicDetail.vue?vue&type=style&index=0&id=6a4163e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports